export default __webpack_public_path__ + "static/media/dataLeakageRealcase-mobile-en.9f893b0f.jpg";